(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["re-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rerise-gallery')) {
  customElements.define('rerise-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const track = this.querySelector('.re-media-track');
      const slides = [...this.querySelectorAll('.re-media-slide')];
      const links = [...this.querySelectorAll('.re-media-thumbnails a')];
      const controls = this.querySelector('.re-media-controls');
      const count = this.querySelector('.re-media-count');
      const dialog = this.querySelector('dialog');
      const enlarged = dialog.querySelector('img');
      const pan = this.querySelector('.re-media-dialog-image');
      const zoom = this.querySelector('[data-re-gallery-zoom]');
      let current = 0;
      let opener;
      let width = track.clientWidth;
      const countText = () => count.dataset.countTemplate.replace('[current]', String(current + 1)).replace('[total]', String(slides.length));
      const resetZoom = () => {
        pan.classList.remove('is-zoomed');
        zoom.setAttribute('aria-pressed', 'false');
        zoom.textContent = zoom.dataset.zoomIn;
        pan.scrollTo(0, 0);
      };
      const showImage = () => {
        const link = slides[current].querySelector('a');
        enlarged.removeAttribute('srcset');
        enlarged.src = link.href;
        enlarged.alt = link.querySelector('img').alt;
        this.querySelector('[data-re-gallery-full]').href = link.href;
        this.querySelector('.re-media-dialog-title').textContent = countText() + ' · ' + slides[current].dataset.label;
        resetZoom();
      };
      const update = () => {
        links.forEach((link, index) => {
          if (index === current) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
          slides[index].querySelector('a').tabIndex = index === current ? 0 : -1;
        });
        count.textContent = countText() + ' · ' + slides[current].dataset.label;
        this.querySelectorAll('[data-re-gallery-direction]').forEach(button => {
          button.disabled = Number(button.dataset.reGalleryDirection) < 0 ? current === 0 : current === slides.length - 1;
        });
        const nav = this.querySelector('.re-media-thumbnails');
        const active = links[current];
        if (active.offsetLeft < nav.scrollLeft || active.offsetLeft + active.offsetWidth > nav.scrollLeft + nav.clientWidth) {
          nav.scrollTo({ left: active.offsetLeft - nav.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2, behavior: 'instant' });
        }
      };
      const move = (index, instant = false) => {
        current = Math.max(0, Math.min(slides.length - 1, index));
        update();
        track.scrollTo({ left: current * track.clientWidth, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        if (dialog.open) showImage();
      };
      controls.hidden = false;
      links.forEach((link, index) => link.addEventListener('click', event => { event.preventDefault(); move(index); }, { signal }));
      this.querySelectorAll('[data-re-gallery-direction]').forEach(button => button.addEventListener('click', () => move(current + Number(button.dataset.reGalleryDirection)), { signal }));
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          update();
        }, 140);
      }, { passive: true, signal });
      slides.forEach((slide, index) => slide.querySelector('a').addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function' || !enlarged) return;
        event.preventDefault();
        current = index;
        opener = event.currentTarget;
        update();
        showImage();
        dialog.showModal();
        document.dispatchEvent(new Event('rerise:viewchange'));
      }, { signal }));
      this.querySelector('[data-re-gallery-close]').addEventListener('click', () => dialog.close(), { signal });
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('button:not(:disabled), a[href], [tabindex="0"]')];
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, { signal });
      dialog.addEventListener('close', () => {
        resetZoom();
        (slides[current]?.querySelector('a') || opener)?.focus({ preventScroll: true });
        document.dispatchEvent(new Event('rerise:viewchange'));
      }, { signal });
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      }, { signal });
      zoom.addEventListener('click', () => {
        const expanded = pan.classList.toggle('is-zoomed');
        zoom.setAttribute('aria-pressed', String(expanded));
        zoom.textContent = expanded ? zoom.dataset.zoomOut : zoom.dataset.zoomIn;
        pan.scrollTo(0, 0);
      }, { signal });
      this.resize = new ResizeObserver(() => {
        if (track.clientWidth !== width) { width = track.clientWidth; move(current, true); }
      });
      this.resize.observe(track);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
      clearTimeout(this.scrollTimer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
